<template>
  <body v-show="startRender">
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back.svg" onclick="history.back();window.close();" class="back" />
      </h1>
      <div class="writer" >
        <div class="profile_pic" v-if="myPhotoUrl == ''" style="background-image: url(/images/basic/img/default.svg)" @click="reportUser()"></div>
        <div class="profile_pic" v-else :style="`background-image: url(${myPhotoUrl});`" @click="reportUser()"></div>
        <div class="user">
          <span style="display: none">Lv.1 </span>
          <span>{{ regNm }}</span>
          <p>{{ boardDetail.ntceDay }}</p>
        </div>
        <div class="post-more">
          <a href="javascript:void(0)" class="opener"><i class="fas fa-ellipsis-h"></i></a>
          <ul class="mores">
            <!-- 작성자일 경우 -->
            <template v-if="boardDetail.regId == userInfo.uniqId">
              <li @click="moveToModifyForm">
                <a><img src="images/basic/icon/edit-post.svg" alt="" />작성글 수정</a>
              </li>
              <li @click="deleteMyPost">
                <a><img src="images/basic/icon/trash-b.svg" alt="" />작성글 삭제</a>
              </li>
            </template>
            <template v-else>
              <!-- 다른 유저일 경우 -->
              <li @click="reportBoard">
                <a href="javascript:void(0)"><img src="images/basic/icon/siren.svg" alt="" />신고하기</a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div class="view">
      <div class="view_wrapper">
        <div class="div_padding"></div>
        <div class="content">
          <template v-if="boardDetail.flieList">
            <div class="attached" v-for="file in boardDetail.flieList" :key="file.orignlFileNm">
              <a href="#" class="file-name">{{ file.orignlFileNm }}</a>
              <a :href="file.downloadUrl" download="hello">
                <img src="images/basic/icon/file-download.svg" alt="" />
              </a>
            </div>
          </template>
          <p v-html="boardContent"></p>
          <div v-for="(img, idx) in boardDetail.imgViewList" :key="idx" class="attached-img">
            <img :src="img.viewUrl" alt="" srcset="" />
          </div>
        </div>
      </div>

      <template v-if="boardDetail.commentAt == 'Y'">
        <div class="community_reply_wrapper">
          <p>
            댓글 <span>+{{ boardDetail.commentCnt }}</span>
          </p>
          <div class="reply_list" v-if="commentList">
            <comment-list-form v-for="(comment, index) in commentList" :key="index" :index="index" :comment="comment" @likeComment="likeComment" @deleteComment="deleteComment" @openUdtBox="openUdtBox" @reportComment="reportComment" @reportCommentUser="reportCommentUser"></comment-list-form>
          </div>
        </div>
      </template>
    </div>

    <div class="reply_box">
      <div class="text_box">
        <textarea placeholder="댓글을 남겨주세요." name="commentContent" rows="4" v-model="newComment"></textarea>
        <input type="button" name="" value="댓글달기" @click="addComment" id="btn_comment_ins" />
      </div>
    </div>
    <!-- 댓글 수정 -->
    <div class="reply_edit_box">
      <div class="reply_edit_wrapper">
        <div class="text_box">
          <textarea placeholder="댓글을 남겨주세요." rows="4" id="commentContent_upd" v-model="myComment" autofocus="true">
        <!-- .each() 메서드는 함수를 이용하여 각각의 요소에게 효과를 줍니다.
        .each() 메서드는 함수의 index를 이용하여 순서를 정할 수 있습니다.
        .each() 메서드는 함수의 index와 element를 이용하여 원하는 요소에 효과를 줍니다. -->
        </textarea
          >
          <input type="button" name="" value="댓글수정" id="btn_comment_upd" @click="updComment" />
          <input type="button" name="" value="취소" />

          <input type="hidden" value="" id="commentId" />
        </div>
      </div>
    </div>

    <div class="view_bottom_menu">
      <p v-if="boardDetail.commentAt == 'Y'">
        <i class="far fa-comment-dots"></i> <span> {{ boardDetail.commentCnt }}</span>
      </p>

      <template v-if="boardDetail.regId != userInfo.uniqId">
        <p :class="boardDetail.likeYn == 'Y' ? 'like ed' : 'like'"  @click="like()">
          <i class="far fa-heart" ></i> <span>{{ boardDetail.likeCnt }}</span>
        </p>
      </template>
      <template v-else>
        <p :class="boardDetail.likeYn == 'Y' ? 'like ed' : 'like'">
          <i class="far fa-heart" ></i> <span>{{ boardDetail.likeCnt }}</span>
        </p>
      </template>
      
      <template v-if="boardDetail.commentAt == 'Y'">
        <div class="reply_btn" @click="toggleReply" :class="{ on: toggleActive }">
          <img src="images/basic/icon/reply-w.svg" alt="" />
        </div>
        <div :class="boardDetail.likeYn == 'Y' ? 'like_btn like ed' : 'like_btn like'" @click="like()" v-show="boardDetail.regId != userInfo.uniqId">
          <i class="fas fa-heart"></i>
        </div>
      </template>
      <template v-else>
        <div class="like_btn like" @click="like()" v-show="boardDetail.regId != userInfo.uniqId">
          <i class="far fa-heart"></i>
        </div>
      </template>
    </div>
  </body>
</template>

<script>
import CommentListForm from "./CommentListForm.vue";
import { fetchBoardDetail, fetchCommentList, likeBoard, addComment, updateComment, deleteComment, deleteBoard, commentLike, reportCommunityBoard } from "@/api/boards";
import $ from "jquery";
export default {
  components: {
    CommentListForm,
  },
  data() {
    return {
      startRender: false,
      boardDetail: {},
      commentList: [],
      myComment: "",
      newComment: "",
      commentId: "",
      udtIdx: 0,
      boardContent: "",
      myPhotoUrl: "",
      toggleActive: false,
      commentPageIndex: 1,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    regNm() {
      return this.boardDetail.userInfo ? this.boardDetail.userInfo.name : this.boardDetail.regNm;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    window.addEventListener("scroll",this.scrollCheck)
  },
  destroyed() {
     window.removeEventListener('scroll', this.scrollCheck);
  },
  methods: {
    scrollCheck(){
      const offset = 20;
      var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,  document.documentElement.clientHeight,  document.documentElement.scrollHeight,  document.documentElement.offsetHeight );
      if ((window.innerHeight + window.scrollY) >= pageHeight - offset) {
        if(this.startRender){
          this.getComment();
        }
      }
    },
    reportUser() {
      var confirm_val = confirm("해당 유저를 신고 하시겠습니까?");
      if(!confirm_val){
        return
      }
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      reportCommunityBoard({
        reportType:"BOARD",
        boardId,
        nttId,
      }).then(({ data }) => {
        console.log("report user",data);
        if (data.resultCode == 2200) {
          alert("이미 신고한 유저 입니다.");
        }
        if (data.resultCode == 1000) {
          alert("해당 유저 신고처리가 완료 되었습니다.");
          this.$router.back();
          window.close();
        }
      });
    },
    async fetchData() {
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;

      const getBoardDetail = await fetchBoardDetail({
        boardId,
        nttId,
      });

      if(getBoardDetail.data.resultCode == 3200){
        alert("존재하지 않는 게시물입니다.");
        this.$router.back();
        window.close();
        return;
      }
      this.boardDetail = getBoardDetail.data.result 
      this.boardContent = this.boardDetail.nttCn; //.replace(/(?:\r\n|\r|\n)/g,"</br>");
      if(this.boardDetail.userInfo != undefined){
        this.myPhotoUrl = this.boardDetail.userInfo.myPhotoUrl;
      }

      const getComments = await fetchCommentList({
        boardId,
        nttId,
        pageIndex:1
      });
      this.commentList = getComments.data.commentList;
      this.addJquery();
      this.startRender = true;
    },
    async like() {
      try {
        const boardId = this.$route.query.boardId;
        const nttId = this.$route.query.nttId;
        const toggleLike = await likeBoard({
          boardId,
          nttId,
        });
        this.boardDetail.likeYn = toggleLike.data.likeYn;
        if (this.boardDetail.likeYn == "Y") {
          this.boardDetail.likeCnt += 1;
        } else {
          this.boardDetail.likeCnt -= 1;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addComment() {
      try {
        if (this.newComment == "") {
          alert("댓글을 입력해 주세요.");
          return;
        }
        if (this.newComment.trim().length < 5) {
          alert("댓글을 5자 이상입력해 주세요.");
          return;
        }
        const boardId = this.$route.query.boardId;
        const nttId = this.$route.query.nttId;
        const addCmt = await addComment({
          boardId,
          nttId,
          commentContent: this.newComment,
        });
        this.refreshData();
        this.fetchData();
        this.newComment = "";
      } catch (error) {
        console.log(error);
      }
    },
    openUdtBox(commentId, idx) {
      this.commentId = commentId;
      this.commentList.filter((comment) => {
        if (comment.commentId == commentId) {
          this.myComment = comment.commentContent;
        }
      });
      this.udtIdx = idx;
      $(".reply_edit_box").slideDown("fast");
      $("#commentContent_upd").focus();
    },
    closeUdtBox() {
      $(".reply_edit_box").slideUp("fast");
      this.refreshData();
    },
    async deleteComment(commentId, idx) {
      if (confirm("댓글을 삭제하시겠습니까?")) {
        try {
          const boardId = this.$route.query.boardId;
          const nttId = this.$route.query.nttId;
          const deltCmt = await deleteComment({
            boardId,
            nttId,
            commentId,
          });
          this.commentList.splice(idx, 1);
          this.boardDetail.commentCnt -= 1;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async updComment() {
      try {
        if (this.myComment == "") {
          alert("댓글을 입력해 주세요.");
          return;
        }
        if (this.myComment.trim().length < 5) {
          alert("댓글을 5자 이상입력해 주세요.");
          return;
        }

        const boardId = this.$route.query.boardId;
        const nttId = this.$route.query.nttId;
        const udtCmt = await updateComment({
          boardId,
          nttId,
          commentId: this.commentId,
          commentContent: this.myComment,
        });
        this.commentList[this.udtIdx].commentContent = this.myComment;
        this.refreshData();
      } catch (error) {
        console.log(error);
      }
    },
    getComment(){
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      this.commentPageIndex = this.commentPageIndex+1;
      fetchCommentList({
        boardId,
        nttId,
        pageIndex: this.commentPageIndex
      }).then(({ data }) => {
        console.log(data);
        this.commentList = [...this.commentList, ...data.commentList];

      });      
    },
    likeComment(commentId) {
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      commentLike({
        boardId,
        nttId,
        commentId,
      }).then(({ data }) => {
        this.fetchData();
      });
    },
    refreshData() {
      this.myComment = "";
      this.commentId = "";
    },
    deleteMyPost() {
      if (confirm("해당 게시글을 삭제 하시겠습니까?")) {
        const boardId = this.$route.query.boardId;
        const nttId = this.$route.query.nttId;
        deleteBoard({
          boardId,
          nttId,
        }).then(({ data }) => {
          if (data.resultCode == 1000) {
            alert("삭제완료");
            this.$router.back()
            window.close();
          }else if(data.resultCode == 3500){
            alert("삭제가 불가능한 게시글입니다.");
          }
        });
      }
    },
    moveToModifyForm() {
      this.$router.push({
        path: "community_modify",
        query: {
          boardId: this.$route.query.boardId,
          nttId: this.$route.query.nttId,
        },
      });
    },
    reportBoard() {
      var confirm_val = confirm("게시글을 신고 하시겠습니까?");
      if(!confirm_val){
        return
      }
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      reportCommunityBoard({
        boardId,
        nttId,
      }).then(({ data }) => {
        console.log(JSON.stringify(data));
        if (data.resultCode == 2200) {
          alert("이미 신고한 게시글 입니다.");
        }
        else if (data.resultCode == 1000) {
          alert("해당 게시글 신고처리가 완료 되었습니다.");
            $('.post-more a').next().slideToggle("fast");
            $('.post-more a').toggleClass("on");
        }
      });
    },
    reportComment(comment){
      var confirm_val = confirm("댓글을 신고 하시겠습니까?");
      if(!confirm_val){
        return
      }
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      reportCommunityBoard({
        boardId,
        nttId,
        commentId:comment.commentId
      }).then(({ data }) => {
        console.log("report user",data);
        if (data.resultCode == 2200) {
          alert("이미 신고한 댓글 입니다.");
        }
        if (data.resultCode == 1000) {
          alert("댓글 신고가 완료되었습니다.");
          this.$router.back();
          window.close();
        }
        if (data.resultCode == 1310){
          alert("신고할 수 없는 유저 입니다.");
        }
      });
    },
    reportCommentUser(comment){
      var confirm_val = confirm("해당 유저를 신고 하시겠습니까?");
      if(!confirm_val){
        return
      }
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      reportCommunityBoard({
        reportType:"COMMENT",
        boardId,
        nttId,
        commentId:comment.commentId
      }).then(({ data }) => {
        console.log("report user",data);
        if (data.resultCode == 2200) {
          alert("이미 신고한 유저 입니다.");
        }
        if (data.resultCode == 1000) {
          alert("유저 신고가 완료되었습니다.");
          this.$router.back();
          window.close();
        }
        if (data.resultCode == 1310){
          alert("신고할 수 없는 유저 입니다.");
        }
      });
    },

    toggleReply() {
      this.toggleActive = !this.toggleActive;
      $(".reply_box").toggleClass("on");
      if ($(".reply_box").hasClass("on") === true) {
        $(".reply_box").slideDown("fast");
        $(".reply_box .text_box textarea").focus();
      } else {
        $(".reply_box").slideUp("fast");
        $(".reply_box .text_box textarea").val("");
      }
    },
    addJquery() {
      if (this.startRender) return;
      $(".reply_box .text_box input").click(function () {
        $(".reply_box").slideToggle("fast");
        $(".reply_box, .reply_btn").removeClass("on");
      });
      $(".post-more a").click(function () {
        $(this).next().slideToggle("fast");
        $(this).toggleClass("on");
      });
      $(".reply_edit").click(function () {
        var commentId = $(this).attr("id");
        var text = $(this).parent().parent().find(".text").text();

        $(".reply_edit_box").toggleClass("on");
        $("body").addClass("comment-edit");
        if ($(".reply_edit_box").hasClass("on") === true) {
          $(".reply_edit_box").slideDown("fast");

          $("#commentId").val(commentId);
          $(".reply_edit_box .text_box textarea").val(text);
          $(".reply_edit_box .text_box textarea").focus();
        } else {
          $(".reply_edit_box").slideUp("fast");
          
        }
      });
      $(".reply_edit_box .text_box input").click(function () {
        $(".reply_edit_box").slideToggle("fast");
        $(".reply_edit_box").removeClass("on");
        $("body").removeClass("comment-edit");
      });
    },
  },
};
</script>

<style scoped>
.like_btn .svg-inline--fa {
  margin-bottom: 4px;
}
.prev_img,
.prev_img img {
  width: 100%;
  height: auto;
}
</style>
